<template>
    <div class="active-tu-selector-component">
        <transition name="fade-fast" mode="out-in">
            <div 
                v-if="anyLoading" 
                key="loadingState" 
                class="min-height-250 d-flex flex-column align-items-center justify-content-center"
            >
                <b-spinner label="Loading Accounts..."></b-spinner>
                <div class="mt-3 special-text">Loading Accounts...</div>
            </div>
            <div v-else-if="tus.length" key="tuList" class="">
                <div class="text-center mb-3">
                    <h5>Select your account:</h5>
                    <p class="mb-1">You have multiple accounts in your organization's portal.</p>
                    <p class="mb-2">Please select the account you want to use:</p>
                </div>
                <div class="mt-4 d-flex flex-column gap-2">
                    <div v-for="(tu, index) in tus" :key="`${index}_tu`">
                        <IdentityLine 
                            :tenantUser="tu"
                            :hideManageAccounts="true"
                            :hidePortalName="true"
                            :hideLogo="true"
                            :nexturl="nexturl"
                            small
                        ></IdentityLine>
                    </div>
                </div>
                <p class="mt-3 font-size-70 text-muted">
                    <span class="font-weight-bold text-primary-darker">NOTE: </span> You can only use one account at a time in a specific web browser (across all tabs).  But you can switch between them as needed.
                </p>
            </div>
            <div v-else-if="!anyLoading && !tus.length" class="mt-4">
                <b-card show variant="info">No accounts found</b-card>
                <b-card class="mt-1">
                    Please contact Supplios support at support@supplios.com
                </b-card>
            </div>
        </transition>
        <div v-if="profilePageUrl" class="mt-4 text-center">
            <a :href="profilePageUrl">Go to your Supplios User Profile page &rarr;</a>
        </div>
    </div>
</template>

<script>

import {suppliosApi} from '@/js/api-service'
import IdentityLine from './identity/IdentityLine.vue';
import { splUrlMapMixin } from '@/js/custom-vue-mixins';

export default {
    name: 'ActiveTuSelector',
    components: {
        IdentityLine
    },
    mixins: [splUrlMapMixin],
    props: {
        tid: {
            type: String,
            required: true
        },
        nexturl: {
            type: String,
            required: false
        }
    },
    data: function() {
        return {
            initialLoadComplete: false,
            loading: false,
            tus: [],
        }
    },
    mounted: function() {
        this.getPossibleTus();
    },
    computed: {
        email() { // must be leftover from something earlier?
            return this.tus.length ? this.tus[0].email : ''
        },
        profilePageUrl() {
            return this.$splUrlMap?.user_profile; // window.splUrlMap.user_profile
        },
        anyLoading() {
            return this.loading || !this.initialLoadComplete;
        },
    },
    methods: {
        async getPossibleTus() {
            this.loading = true;
            const data = await suppliosApi.auth.getPossibleActiveTus(this.tid);
            this.tus = data;
            this.loading = false;
            this.initialLoadComplete = true;
        },
    }
}
</script>

<style lang="scss">
</style>
